/**
 * 商城模板分類預設值（API 未回傳或舊快取時後台顯示用，與後端 DEFAULT 語意一致）
 */
import { cloneBaseStorefrontThemePresets } from './storefrontTemplateThemePresets.js'

function tpl(value, label, description, disabled = false) {
  return { value, label, description, disabled, themes: cloneBaseStorefrontThemePresets() }
}

export const DEFAULT_STOREFRONT_TEMPLATE_CATEGORIES = [
  {
    id: 'general',
    label: '通用與基礎',
    description: '不特定產業的基礎版型，同一分類內可並列多種動線與區塊組合。',
    templates: [
      tpl('standard', '通用標準', '預設結構，適用多數商店；前台依代碼 standard 掛載。'),
      tpl('retail', '零售精選', '偏重商品瀏覽、促銷與分類導覽（前台實作對應後生效）。'),
      tpl('showcase', '櫥窗型', '首頁大圖／故事區塊為主，適合品牌形象與主打系列。'),
    ],
  },
  {
    id: 'industry',
    label: '產業情境',
    description: '依產業預設常用區塊與動線；同一產業類型亦可提供多種變體模板。',
    templates: [
      tpl('bakery', '烘焙甜點', '烘焙／甜點族群適用之版型（前台實作對應後生效）。'),
      tpl('dining', '餐飲輕食', '輕食／簡餐適用之版型（前台實作對應後生效）。', true),
      tpl('beverage', '飲品咖啡', '飲品、咖啡吧類型之動線與區塊（前台實作對應後生效）。', true),
    ],
  },
  {
    id: 'style',
    label: '風格取向',
    description: '以整體視覺與版面氣氛區分，可與「主題（配色）」搭配。',
    templates: [
      tpl('style_warm', '溫暖親民', '圓角、暖色調版面節奏（前台依代碼掛載）。', true),
      tpl('style_modern', '現代俐落', '留白、強對比與較緊湊的資訊層級（前台依代碼掛載）。'),
    ],
  },
]
